import { effects, registerEventHandler } from 'reffects';
import { state } from 'reffects-store';
import { cookies, globals, http } from 'reffects-batteries';

export default function registerCookiePolicyDialogEvents() {
    registerEventHandler(
        'INITIALIZE_COOKIE_POLICY_DIALOG',
        function initializeCookiePolicyDialog({
            cookie: { cookiePolicyRejected },
        }) {
            return {
                ...state.set({
                    cookiePolicyDialog: {},
                    isCookiePolicyRejected: cookiePolicyRejected === 'true',
                }),
                ...effects.dispatch('ACCEPTED_LEGAL_DOCUMENT_CACHE.RETRIEVE', {
                    documentName: 'cookie_policy',
                }),
            };
        },
        [cookies.get('cookiePolicyRejected')]
    );

    registerEventHandler(
        'COOKIE_POLICY_WAS_ACCEPTED',
        function cookiePolicyWasAccepted({
            globals: {
                trovitData: { locale },
            },
        }) {
            return {
                ...state.set({
                    'cookiePolicyDialog.isDocumentSubmitting': true,
                }),
                ...http.post({
                    url: '/index.php/cod.legal_documents_accept',
                    body: { locale, documentNames: ['cookie_policy'] },
                    successEvent: ['COOKIE_POLICY_ACCEPTED'],
                    errorEvent: ['COOKIE_POLICY_ACCEPT_FAILED'],
                }),
            };
        },
        [globals.get('trovitData')]
    );

    registerEventHandler(
        'COOKIE_POLICY_ACCEPTED',
        function cookiePolicyAccepted() {
            return {
                ...cookies.remove({ key: 'cookiePolicyRejected' }),
                ...state.set({
                    'cookiePolicyDialog.isDocumentSubmitting': false,
                    isCookiePolicyRejected: false,
                }),
                ...effects.dispatch('RELOAD_ACCEPTED_LEGAL_DOCUMENT', {
                    documentName: 'cookie_policy',
                }),
            };
        }
    );

    registerEventHandler(
        'COOKIE_POLICY_ACCEPT_FAILED',
        function cookiePolicyAcceptanceFailed() {
            return {
                ...cookies.remove({ key: 'cookiePolicyRejected' }),
                ...state.set({
                    'cookiePolicyDialog.isDocumentSubmitting': false,
                    isCookiePolicyRejected: false,
                }),
            };
        }
    );

    registerEventHandler(
        'COOKIE_POLICY_REJECTED',
        function cookiePolicyRejected() {
            return {
                ...cookies.set({ key: 'cookiePolicyRejected', value: true }),
                ...state.set({
                    'cookiePolicyDialog.isDocumentSubmitting': false,
                    isCookiePolicyRejected: true,
                }),
            };
        }
    );
}
